import { render, staticRenderFns } from "./WealthTemaplte_ElVerticalMenu.vue?vue&type=template&id=473fc944"
import script from "./WealthTemaplte_ElVerticalMenu.vue?vue&type=script&lang=js"
export * from "./WealthTemaplte_ElVerticalMenu.vue?vue&type=script&lang=js"
import style0 from "./WealthTemaplte_ElVerticalMenu.vue?vue&type=style&index=0&id=473fc944&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports